import { styled } from '@mui/system'
import { colors } from '../consts'

type ThemeProps = {
  uiTheme: 'light' | 'dark'
  wideFirstCol?: boolean
}

export const StandingsTableCon = styled('table')<ThemeProps>(
  ({ uiTheme, wideFirstCol, theme }) => ({
    width: '100%',
    borderCollapse: 'collapse',
    background: uiTheme === 'dark' ? 'none' : colors.white,
    margin: theme.spacing(2, 1),
    [theme.breakpoints.up('md')]: {
      maxWidth: 360,
    },

    '& thead th': {
      fontSize: 10,
      color: uiTheme === 'dark' ? colors.white : colors.text,
      fontWeight: 'normal',
      textTransform: 'uppercase',
      height: theme.spacing(3),
      '&:first-of-type': {
        textAlign: 'left',
        width: wideFirstCol ? '50%' : 'auto',
        fontWeight: 800,
        [theme.breakpoints.down('md')]: {
          width: wideFirstCol ? '60%' : 'auto',
        },
      },
    },
    '& tbody tr': {
      borderTop: `1px solid ${colors.lightGrey}`,
      '&:first-of-type': {
        borderTop: 0,
      },
    },

    '& tbody td': {
      fontSize: 14,
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      color: uiTheme === 'dark' ? colors.white : colors.text,
      width: wideFirstCol ? 50 : '13%',
      minWidth: 28,
      textAlign: 'center',
      fontWeight: 600,
      [theme.breakpoints.down('md')]: {
        minWidth: 15,
      },
      '&:first-of-type': {
        width: wideFirstCol ? '50%' : 'auto',
        textAlign: 'left',
        [theme.breakpoints.down('md')]: {
          width: wideFirstCol ? '60%' : 'auto',
        },
      },
      '& a': {
        color: uiTheme === 'dark' ? colors.white : colors.text,
        textDecoration: 'none',
      },
      '& svg': {
        width: 18,
        marginLeft: theme.spacing(1),
      },
    },
    '& tfoot td': {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      textAlign: 'center',
      fontWeight: 'normal',
      fontSize: 10,
      color: uiTheme === 'dark' ? colors.white : colors.text,
    },
  })
)

export const StandingsTableFullCon = styled('table')<ThemeProps>(
  ({ uiTheme, wideFirstCol, theme }) => ({
    width: '100%',
    borderCollapse: 'collapse',
    background: uiTheme === 'dark' ? 'none' : colors.white,
    margin: theme.spacing(4, 1, 1, 1),
    [theme.breakpoints.up('md')]: {
      maxWidth: '98%',
    },

    '& thead th': {
      fontSize: 14,
      color: uiTheme === 'dark' ? colors.white : colors.text,
      fontWeight: 'normal',
      textTransform: 'uppercase',
      height: theme.spacing(3),
      [theme.breakpoints.down('md')]: {
        fontSize: 12,
      },
      '&:first-of-type': {
        textAlign: 'left',
        width: wideFirstCol ? '60%' : 'auto',
        fontWeight: 800,
        [theme.breakpoints.down('md')]: {
          fontSize: 12,
        },
      },
    },
    '& tbody tr': {
      borderTop: `1px solid ${colors.lightGrey}`,
      '&:first-of-type': {
        borderTop: 0,
      },
    },

    '& tbody td': {
      fontSize: 14,
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      color: uiTheme === 'dark' ? colors.white : colors.text,
      width: wideFirstCol ? 50 : '13%',
      minWidth: 28,
      textAlign: 'center',
      fontWeight: 600,
      [theme.breakpoints.down('md')]: {
        width: 30,
        fontSize: 12,
      },
      '&:first-of-type': {
        width: wideFirstCol ? '60%' : 'auto',
        textAlign: 'left',
      },
      '& a': {
        color: uiTheme === 'dark' ? colors.white : colors.text,
        textDecoration: 'none',
      },
      '& svg': {
        width: 18,
        marginLeft: theme.spacing(1),
      },
    },
    '& tfoot td': {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      textAlign: 'center',
      fontWeight: 'normal',
      fontSize: 10,
      color: uiTheme === 'dark' ? colors.white : colors.text,
    },
  })
)

export const StandingsTypeCon = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  margin: theme.spacing(1, 2, 2),
  [theme.breakpoints.down('md')]: {
    margin: theme.spacing(1, 0, 1.5),
  }
}))
